import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import {Link} from 'react-router';
import classNames from 'classnames';
import _ from 'lodash';

import './left-side.less';
import {connect} from "react-redux";
import {closeSubmenu, openSubmenu} from "store/reducers/menu";
import * as alerts from "helpers/alerts";
import $ from 'jquery';
import IScroll from 'iscroll';

@propTypes({
    menu: PropTypes.array
})

@defaultProps({
    menu: [],
})

@connect((state) => ({
    submenu: state.menu.get('submenu'),
}), {openSubmenu, closeSubmenu})

export default class LeftSide extends Component {
    state = {
        opened: false
    };

    updateCount = 0;

    componentDidUpdate() {
        this.updateCount++;
        //if (!$('.sub-menu_open').length) {
            new IScroll('.left-menu__wrapper', {
                mouseWheel: true,
                scrollbars: false,
                click: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
            });
        /*} else {
            new IScroll('.sub-menu_open', {
                mouseWheel: true,
                scrollbars: false,
                click: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
            });
        }*/
    }

    componentDidMount() {
        this.forceUpdate();
    }

    render() {
        const menuClassName = classNames('left-menu', this.state.opened ? 'left-menu_expanded' : '');
        const buttonsClassName = classNames('left-menu-button', this.state.opened ? 'left-menu-button_open' : '');

        return (
            <div className={menuClassName}>
                <a href="#" className={buttonsClassName} onClick={::this.toggleMenu}/>

                <div className="left-menu__wrapper">
                    <ul className="left-menu__list">
                        {this.props.menu.map(::this.renderItem)}
                        {window.RNIS_SETTINGS.HIDECOPYRIGHT ? null : <li className="left-menu__version">© <a href="https://www.t1-group.ru">АО «Группа Т-1»</a><br/>2017-2021</li>}
                        {window.RNIS_SETTINGS.CITY_MURMANSK ? <li className="left-menu__version">
                            <a href="https://nashsever51.ru">
                                <img src="/static/img/ns.png" alt="" width={"50px"}/>
                            </a></li> : null}
                        {window.RNIS_SETTINGS.CITY_MURMANSK ? <li className="left-menu__version_smut">Наш Север<br/></li> : null }
                    </ul>
                </div>
            </div>
        );
    }

    toggleMenu(e) {
        e.preventDefault();

        this.setState({
            opened: !this.state.opened
        });
    }

    renderItem(item, i) {
        let link;
        if (!item) return;

        if (item.route) {
            link = <Link key={i} className={`left-menu__link ${item.class}`} activeClassName={window.RNIS_SETTINGS.CITY_MURMANSK ? 'active smut' : 'active'} to={item.route}
                         onClick={item.onClick || ::this.closeAlerts}>
                {item.counter}
                <span className="left-menu__text">{item.text}</span>
                <span className="left-menu__title">{item.text}</span>
            </Link>
        } else if (item.href) {
            link = <a key={i} target="_blank" className={`left-menu__link ${item.class}`} href={item.href}
                      onClick={item.onClick || ::this.closeAlerts}>
                {item.counter}
                <span className="left-menu__text">{item.text}</span>
                <span className="left-menu__title">{item.text}</span>
            </a>
        } else {
            link = <a key={i} className={`left-menu__link ${item.class}`} href="#"
                      onClick={this.openSubmenu.bind(this, item.key)}>
                {item.counter}
                <span className="left-menu__text">{item.text}</span>
                <span className="left-menu__title">{item.text}</span>
            </a>
        }

        let submenu = null;
        if (item.submenu) {
            if (!this.hasSubmenu(item)) {
                return null;
            }
            const submenuClass = classNames('sub-menu', (item.key && this.props.submenu.indexOf(item.key) !== -1) ? 'sub-menu_open' : '');
            submenu = <div className={submenuClass}>
                <ul className="left-menu__list">
                    <li className="left-menu__item">
                        <a className="left-menu__link back" href="#" onClick={::this.closeSubmenu}>
                            <span className="left-menu__text">Вернуться назад</span>
                            <span className="left-menu__title">Вернуться назад</span>
                        </a>
                    </li>
                    {item.submenu.map(::this.renderItem)}
                </ul>
            </div>;
        }

        return (
            <li key={i} className={classNames('left-menu__item', item.superclass)}>
                {link}
                {submenu}
            </li>
        );
    }

    hasSubmenu(item) {
        return _.filter(item.submenu, (item) => {
            if (!item) return false;
            if (!item.permission) {
                return true;
            }
            return true;
        }).length > 0;
    }

    closeAlerts() {
        alerts.close();
    }

    openSubmenu(submenuKey, e) {
        e.preventDefault();
        this.props.openSubmenu(submenuKey);
    }

    closeSubmenu(e) {
        e.preventDefault();
        this.props.closeSubmenu();
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/left-side.js